import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MMM YYYY',
  },
  display: {
    dateInput: 'MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-custom-date-popup',
  templateUrl: './custom-date-popup.component.html',
  styleUrls: ['./custom-date-popup.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class CustomDatePopupComponent implements OnInit {
  @ViewChild('effectivedate') startDatePicker: MatDatepicker<Date>;
  form: FormGroup;
  dateControl: FormControl;
  Maxdate: Date
  Mindate: Date;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CustomDatePopupComponent>,
    private fb: FormBuilder,
    private dateAdapter: DateAdapter<any>
  ) {
    this.dateAdapter.setLocale('en-US');
    this.form = this.fb.group({
      effectivedate: new FormControl(moment().format('MMM YYYY')) // Set initial value here
    });
    this.dateControl = this.form.get('effectivedate') as FormControl;
  }

  ngOnInit(): void {
    console.log('Page name passed to dialog:', this.data.pageName);
    const today = new Date();
    if (this.data.pageName === 'Suspension') {
      this.Maxdate = new Date(today.getFullYear(), today.getMonth() + 6, today.getDate());
      // this.Mindate = today;
    } else {
      this.Maxdate = today;
      this.Mindate = null;

    }

  }

  chosenYearHandler(normalizedYear: Date) {
    const currentDate = this.dateControl.value ? moment(this.dateControl.value, 'MMM YYYY') : moment();
    currentDate.year(normalizedYear.getFullYear());
    this.dateControl.setValue(currentDate.format('MMM/YYYY'));
    console.log("Year Selected: ", this.dateControl.value);
  }

  chosenMonthHandler(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    const currentDate = this.dateControl.value ? moment(this.dateControl.value, 'MMM YYYY') : moment();
    currentDate.month(normalizedMonth.getMonth());
    this.dateControl.setValue(currentDate.format('MMM YYYY'));
    datepicker.close();
    console.log("Month Selected: ", this.dateControl.value);
    this.dialogRef.close(this.dateControl.value);

  }

  Close() {
    this.dialogRef.close(this.dateControl.value);
  }
}
